module.exports = __webpack_public_path__ + "static/media/MEDIALOGO PROTONES DEF.80db2ad2.mp4";